// extracted by mini-css-extract-plugin
module.exports = {"ErrorPopup":"ErrorPopup_ErrorPopup__3KC4O","ErrorPopup__text":"ErrorPopup_ErrorPopup__text__3_9L6","ErrorPopup__close":"ErrorPopup_ErrorPopup__close__3Wwsu"};